
//import { gsap } from 'gsap';
//import DOMHelpers from '../utils/dom-helpers';


export default class{

    constructor( options ) {
        this.defaults = {
        	el:                    false,
            active:                 true,

            time_read_response:     3000,
            attachToElement:        false,

            debug                  : false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'bonterra_newsletter_form';
		this.el 			= 	this.options.el;
		this.main			=   this.options.main;


        if ( this.options.attachToElement ){
            this.options.attachToElement.append( this.el );
        }


        this.response   = this.el.querySelector( '.response' );
        this.close      = this.el.querySelector( '.close' );
        this.form       = this.el.getElementsByTagName( 'form' )[0];

        this.id_timeout_response = false;

		this.init( true );

        if ( this.options.debug ){
            if ( this.options.anchor ){
                this.toggle();
            }
        }
		
    }

    init( b ){
    	this.addEvents( b );
	}

    log(str){
        console.log( this.namespace + ' :: ' + str );
    }

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
            if ( this.options.anchor ){
                this.options.anchor.addEventListener( 'click', this.toggleNewsletter );
            }
            this.close.addEventListener( 'click', this.closeNewsletter );
		}
		else{
            if ( this.options.anchor ){
                this.options.anchor.removeEventListener( 'click', this.toggleNewsletter );
            }
            this.close.removeEventListener( 'click', this.closeNewsletter );
		}
        // this.ajaxifyForm(b);
	}

    toggleNewsletter = (e)=>{
        e.preventDefault();
        e.stopImmediatePropagation();
        this.toggle();
    }

    closeNewsletter = (e)=>{
        e.preventDefault();
        e.stopImmediatePropagation();
        this.open(false);
    }
   
    addClickOut( b ){
        if ( b ){
            document.addEventListener( 'click', this.clickOut )
        }
        else{
            document.removeEventListener( 'click', this.clickOut )
        }
    }

    clickOut = ( e ) => {
        // Check if the clicked element (event.target) is NOT inside myElement
        if (! this.el.contains(e.target)) {
            this.open( false );
        }   
    }

    ajaxifyForm(b){
        if ( b ){
            this.form.addEventListener('submit', this.fetchForm );
        }
        else{
            this.form.removeEventListener('submit', this.fetchForm );
        }
    }

    fetchForm = async ( event ) => {

        // Prevent the default form submission that causes a page reload
        event.preventDefault();

        this.setLoading( true );

        // Get form data
        const formData = new FormData(this.form),
            // Get the form's action and method
            formAction = this.form.getAttribute('action')?this.form.getAttribute('action'):document.location.href,
            formMethod = this.form.getAttribute('method');

        try {

            // Send the form data using the Fetch API
            const response = await fetch(formAction, {
                method: formMethod,
                body: formData,
                // The browser automatically sets the correct Content-Type for FormData
            });

            // Handle the server's response
            if (response.ok) {
                // Successful response

                // Get the response body as a text string
                const htmlString = await response.text(),
                    // Create a new parser
                    parser = new DOMParser(),
                    // Parse the HTML string into a Document object
                    html = parser.parseFromString(htmlString, 'text/html');

                let formResponse = html.querySelector( '.mc4wp-response' );

                this.setResponse( true, formResponse.textContent );

            } else {
                // Error response from the server
                this.setResponse( false, 'HTTP error! Status: ' . response.status );
            }
        } 
        catch (error) {
            // Network or other fetch-related errors
            this.setResponse( false, error );
        }
    }

    setLoading(b){
        if ( this.main ){
            this.main.setLoading(b);
        }
        if ( b ){
            this.el.classList.add( 'loading' );
        }
        else{
            this.el.classList.remove( 'loading' );
        }
    }

    setResponse( success , message ){
        this.setLoading( false );
        this.response.textContent = message;
        if ( success ){
            this.form.reset(); // Clear the form fields
        }
        else{

        }
        this.el.classList.add( 'response-active' );
        this.id_timeout_response = setTimeout( ()=> this.endResponse(), this.options.time_read_response );
    }

    endResponse(){
        this.el.classList.remove( 'response-active' );
    }

    toggle(){
        this.open( ! this.el.classList.contains( 'open-win' ) )
    }

    open( b ){
        if ( b ){
            this.el.classList.add( 'open-win' );
        }
        else{
            this.el.classList.remove( 'open-win' );
        }
        this.addClickOut( b );
    }

    destroy(){
        this.addClickOut( false );
		this.init( false );
    }

}


